// src/services/firestoreService.js
import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Save specific user data to Firestore
 * @param {string} userId - The user's unique ID (e.g., Firebase UID)
 * @param {object} userData - The data to save (e.g., name, email, preferences)
 * @returns {Promise<void>} - Resolves when the data is saved
 */
export const saveUserData = async (userId, userData) => {
	try {
		// Create a reference to the user's document in the "users" collection
		const userDocRef = doc(db, "users", userId);
		// Save the data to Firestore
		await setDoc(userDocRef, userData, { merge: true }); // Merge prevents overwriting existing data
		console.log("User data saved successfully!");
		// window.location.reload();
	} catch (error) {
		console.error("Error saving user data:", error);
		throw error; // Rethrow the error to handle it in the calling function
	}
};

export const fetchUserData = async (userId) => {
	const userRef = doc(db, "users", userId);
	const userDoc = await getDoc(userRef);
	return userDoc.exists() ? userDoc.data() : null;
};
